import { Panel, useRevealPanel } from '@scout/ui/shell'
import { createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'

import { CrawlLog } from '@/corpus/CrawlLog'

export const Route = createFileRoute('/admin/crawls/$requestId')({ component: CrawlLogPage })

/**
 * One request's log, in the panel beside the table it was opened from.
 *
 * The same slot a product's reading occupies, and for the same reason: what is
 * in the panel is context for what is in the main column. An operator watching
 * a crawl land wants the queue still in front of them — the next request is
 * usually the one they are about to ask about.
 */
function CrawlLogPage() {
  const { requestId } = Route.useParams()

  // Keyed, so opening a second request from the table is a new panel rather
  // than the same one with a different parameter. That is what makes the
  // effect below fire again, and it says so in the tree rather than in a
  // dependency array that has to be read carefully to see why it is right.
  return <OpenedInThePanel key={requestId} requestID={requestId} />
}

function OpenedInThePanel({ requestID }: { requestID: string }) {
  const reveal = useRevealPanel()

  // Below `xl` the panel is closed until something opens it, so arriving here
  // has to say so. Without this, pressing View on a narrow screen changes the
  // address and nothing appears to happen — which is worse than the link doing
  // nothing at all, because the operator has no reason to go looking for a
  // toggle. A no-op above `xl`, where the panel always has a track of its own.
  useEffect(() => {
    reveal()
  }, [reveal])

  return (
    <Panel>
      <CrawlLog requestID={requestID} />
    </Panel>
  )
}
